var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPageGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 8.0332L15 8.0332C14.7348 8.0332 14.4804 7.92785 14.2929 7.74031C14.1054 7.55277 14 7.29842 14 7.0332L14 3.0332",
    stroke: "#636874",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 21.0332L7 21.0332C6.46957 21.0332 5.96086 20.8225 5.58579 20.4474C5.21071 20.0723 5 19.5636 5 19.0332L5 5.0332C5 4.50277 5.21071 3.99406 5.58579 3.61899C5.96086 3.24392 6.46957 3.0332 7 3.0332L14 3.0332L19 8.0332L19 19.0332C19 19.5636 18.7893 20.0723 18.4142 20.4474C18.0391 20.8225 17.5304 21.0332 17 21.0332V21.0332Z",
    stroke: "#636874",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageGrey);
export default __webpack_public_path__ + "static/media/page-grey.b91e6738cc15d8067bc74629cdf7e609.svg";
export { ForwardRef as ReactComponent };